// extracted by mini-css-extract-plugin
export var errorIcon = "_kt-1";
export var nameLogo = "_kt-0";